module.exports = __webpack_public_path__ + "static/media/logo.f07cf93c.svg";